import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import PersonOutline from "@mui/icons-material/PersonOutline";
import PhoneOutlined from "@mui/icons-material/PhoneOutlined";
import LocationOnOutlined from "@mui/icons-material/LocationOnOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import CheckBox from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";
import StoreCardSkeleton from "./StoreCardSkeleton.jsx";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ACCENT = "#0798f0";

function StoreCard({ store, selected, onSelect }) {
  const [activeProductIndex, setActiveProductIndex] = useState(0);

  const products = store.products || [];
  const activeProduct = products[activeProductIndex];

  return (
    <div
      //   onClick={() => onSelect(store.details?.id)}
      className={`group w-full  cursor-pointer overflow-hidden rounded-xl border bg-white shadow-sm transition-all duration-200 ${
        selected
          ? "border-[#0798f0] bg-[#f8fcff] shadow-md ring-1 ring-[#0798f0]/20"
          : "border-gray-200 hover:border-[#0798f0]/50 hover:shadow-md"
      }`}
    >
      {/* ================= STORE HEADER ================= */}
      <div className="flex items-start justify-between border-b border-gray-100 px-4 py-3">
        <div className="min-w-0">
          <h3 className="truncate text-[14px] font-semibold text-gray-800">
            {store.details?.storeName}
          </h3>
        </div>

        {/* <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onSelect(store.details?.id);
          }}
          className="ml-3 flex-shrink-0 rounded-md transition hover:bg-blue-50"
        >
          {selected ? (
            <CheckBox sx={{ fontSize: 21, color: ACCENT }} />
          ) : (
            <CheckBoxOutlineBlank sx={{ fontSize: 21, color: "#94a3b8" }} />
          )}
        </button> */}
      </div>

      {/* ================= OWNER + ADDRESS ================= */}
      <div className="space-y-2 px-4 py-3">
        <div className="flex items-center gap-2 text-[14px] text-gray-600">
          <PersonOutline sx={{ fontSize: 15, color: "#64748b" }} />
          <span className="truncate">
            {store.details?.storeOwnerName || "N/A"}
          </span>
          <span className="ml-auto flex items-center gap-1 whitespace-nowrap text-[14px] text-gray-500">
            <PhoneOutlined sx={{ fontSize: 14, color: "#64748b" }} />
            {store.details?.storeOwnerPhoneNumber || "N/A"}
          </span>
        </div>

        <div className="flex items-start gap-2 text-[14px] leading-4 text-gray-600">
          <LocationOnOutlined
            sx={{ fontSize: 15, color: "#64748b", marginTop: "1px" }}
            className="flex-shrink-0"
          />
          <span>
            {[
              store.details?.address,
              store.details?.city,
              store.details?.state,
              store.details?.zipCode,
            ]
              .filter(Boolean)
              .join(", ") || "Address not available"}
          </span>
        </div>
      </div>

      {/* ================= PRODUCT DETAILS (TABS) ================= */}
      <div className="border-t border-blue-100 bg-gradient-to-r from-blue-50 to-sky-50 px-4 py-3">
        <div className="mb-2 flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-[#0798f0]/10">
            <Inventory2Outlined sx={{ fontSize: 14, color: ACCENT }} />
          </div>
          <p className="text-[10px] font-semibold uppercase tracking-wide text-[#64748b]">
            Product details {products.length > 1 && `(${products.length})`}
          </p>
        </div>

        {products.length === 0 ? (
          <div className="rounded-lg border border-blue-100 bg-white px-3 py-2 text-[12px] text-gray-400">
            No products assigned
          </div>
        ) : (
          <>
            {/* Tabs — only rendered when there's more than one product */}
            {products.length > 0 && (
              <div className="mb-2 flex flex-wrap gap-1.5">
                {products.map((prod, i) => (
                  <button
                    key={prod.id}
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveProductIndex(i);
                    }}
                    className={`rounded-full border px-2.5 py-1 text-[11px] font-medium transition ${
                      i === activeProductIndex
                        ? "border-[#0798f0] bg-[#0798f0] text-white"
                        : "border-blue-200 bg-white text-gray-600 hover:border-[#0798f0]/50"
                    }`}
                  >
                    {prod.productType}
                  </button>
                ))}
              </div>
            )}

            {/* Active product's Type / Size */}
            <div className="grid grid-cols-2 gap-2">
              <div className="rounded-lg border border-blue-100 bg-white px-3 py-2">
                <span className="text-[12px] font-medium uppercase tracking-wide text-gray-400">
                  Type:
                </span>
                <span className="mt-0.5 truncate text-[12px] font-semibold text-gray-700">
                  {" "}
                  {activeProduct?.productType || "N/A"}
                </span>
              </div>

              <div className="rounded-lg border border-blue-100 bg-white px-3 py-2">
                <span className="text-[12px] font-medium uppercase tracking-wide text-gray-400">
                  Size:
                </span>
                <span className="mt-0.5 truncate text-[12px] font-semibold text-gray-700">
                  {" "}
                  {activeProduct?.approvedWidth || 0}
                  {" × "}
                  {activeProduct?.approvedHeight || 0} {" sq. ft."}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const dummyStores = [
  {
    details: {
      id: "store_001",
      storeName: "Delhi Supermart",
      storeOwnerName: "Amit Kumar",
      storeOwnerPhoneNumber: "9876543211",
      address: "Main Road",
      city: "Delhi",
      state: "Delhi",
      zipCode: "110001",
    },
    products: [
      {
        id: "prod_001",
        productType: "GSB (SS)",
        approvedWidth: 6,
        approvedHeight: 4,
      },
      {
        id: "prod_002",
        productType: "Standee",
        approvedWidth: 2,
        approvedHeight: 5,
      },
      {
        id: "prod_003",
        productType: "Wall Wrap",
        approvedWidth: 10,
        approvedHeight: 8,
      },
    ],
  },
  {
    details: {
      id: "store_002",
      storeName: "East Delhi Supermart",
      storeOwnerName: "Amit Reddy",
      storeOwnerPhoneNumber: "9876543669",
      address: "Main Road",
      city: "East Delhi",
      state: "Delhi",
      zipCode: "110036",
    },
    products: [
      {
        id: "prod_004",
        productType: "GSB (SS)",
        approvedWidth: 5,
        approvedHeight: 4,
      },
    ],
  },
  {
    details: {
      id: "store_003",
      storeName: "North Delhi Supermart",
      storeOwnerName: "Neha Kumar",
      storeOwnerPhoneNumber: "9876543667",
      address: "Main Road",
      city: "North Delhi",
      state: "Delhi",
      zipCode: "110058",
    },
    products: [
      {
        id: "prod_005",
        productType: "GSB (SS)",
        approvedWidth: 4,
        approvedHeight: 3,
      },
      {
        id: "prod_006",
        productType: "Glow Sign",
        approvedWidth: 3,
        approvedHeight: 2,
      },
      {
        id: "prod_007",
        productType: "Standee",
        approvedWidth: 2,
        approvedHeight: 5,
      },
      {
        id: "prod_008",
        productType: "Wall Wrap",
        approvedWidth: 12,
        approvedHeight: 6,
      },
    ],
  },
  {
    details: {
      id: "store_004",
      storeName: "Gurgaon Central Mart",
      storeOwnerName: "Rahul Sharma",
      storeOwnerPhoneNumber: "9876543212",
      address: "MG Road",
      city: "Gurgaon",
      state: "Haryana",
      zipCode: "122001",
    },
    products: [
      {
        id: "prod_009",
        productType: "GSB (SS)",
        approvedWidth: 8,
        approvedHeight: 5,
      },
      {
        id: "prod_010",
        productType: "Standee",
        approvedWidth: 3,
        approvedHeight: 6,
      },
    ],
  },
  {
    details: {
      id: "store_005",
      storeName: "Noida Fresh Mart",
      storeOwnerName: "Priya Singh",
      storeOwnerPhoneNumber: "9876543213",
      address: "Sector 18 Market",
      city: "Noida",
      state: "Uttar Pradesh",
      zipCode: "201301",
    },
    products: [
      {
        id: "prod_011",
        productType: "Wall Wrap",
        approvedWidth: 14,
        approvedHeight: 8,
      },
      {
        id: "prod_012",
        productType: "Glow Sign",
        approvedWidth: 5,
        approvedHeight: 3,
      },
      {
        id: "prod_013",
        productType: "GSB (SS)",
        approvedWidth: 6,
        approvedHeight: 4,
      },
    ],
  },
  {
    details: {
      id: "store_006",
      storeName: "Faridabad Super Store",
      storeOwnerName: "Rohit Verma",
      storeOwnerPhoneNumber: "9876543214",
      address: "Mathura Road",
      city: "Faridabad",
      state: "Haryana",
      zipCode: "121001",
    },
    products: [
      {
        id: "prod_014",
        productType: "Standee",
        approvedWidth: 2,
        approvedHeight: 6,
      },
      {
        id: "prod_015",
        productType: "Wall Wrap",
        approvedWidth: 10,
        approvedHeight: 7,
      },
    ],
  },
  {
    details: {
      id: "store_007",
      storeName: "Jaipur Daily Needs",
      storeOwnerName: "Sandeep Mehta",
      storeOwnerPhoneNumber: "9876543215",
      address: "MI Road",
      city: "Jaipur",
      state: "Rajasthan",
      zipCode: "302001",
    },
    products: [
      {
        id: "prod_016",
        productType: "GSB (SS)",
        approvedWidth: 7,
        approvedHeight: 4,
      },
      {
        id: "prod_017",
        productType: "Glow Sign",
        approvedWidth: 4,
        approvedHeight: 3,
      },
      {
        id: "prod_018",
        productType: "Standee",
        approvedWidth: 3,
        approvedHeight: 5,
      },
    ],
  },
  {
    details: {
      id: "store_008",
      storeName: "Mumbai Value Mart",
      storeOwnerName: "Karan Patel",
      storeOwnerPhoneNumber: "9876543216",
      address: "Linking Road",
      city: "Mumbai",
      state: "Maharashtra",
      zipCode: "400050",
    },
    products: [
      {
        id: "prod_019",
        productType: "Wall Wrap",
        approvedWidth: 16,
        approvedHeight: 9,
      },
      {
        id: "prod_020",
        productType: "GSB (SS)",
        approvedWidth: 8,
        approvedHeight: 5,
      },
      {
        id: "prod_021",
        productType: "Glow Sign",
        approvedWidth: 6,
        approvedHeight: 4,
      },
    ],
  },
  {
    details: {
      id: "store_009",
      storeName: "Bangalore Smart Store",
      storeOwnerName: "Ananya Rao",
      storeOwnerPhoneNumber: "9876543217",
      address: "Indiranagar Main Road",
      city: "Bangalore",
      state: "Karnataka",
      zipCode: "560038",
    },
    products: [
      {
        id: "prod_022",
        productType: "GSB (SS)",
        approvedWidth: 5,
        approvedHeight: 3,
      },
      {
        id: "prod_023",
        productType: "Standee",
        approvedWidth: 2,
        approvedHeight: 5,
      },
      {
        id: "prod_024",
        productType: "Wall Wrap",
        approvedWidth: 11,
        approvedHeight: 7,
      },
      {
        id: "prod_025",
        productType: "Glow Sign",
        approvedWidth: 4,
        approvedHeight: 3,
      },
    ],
  },
  {
    details: {
      id: "store_010",
      storeName: "Hyderabad Mega Mart",
      storeOwnerName: "Vikram Reddy",
      storeOwnerPhoneNumber: "9876543218",
      address: "Banjara Hills Road",
      city: "Hyderabad",
      state: "Telangana",
      zipCode: "500034",
    },
    products: [
      {
        id: "prod_026",
        productType: "GSB (SS)",
        approvedWidth: 6,
        approvedHeight: 4,
      },
      {
        id: "prod_027",
        productType: "Wall Wrap",
        approvedWidth: 13,
        approvedHeight: 8,
      },
    ],
  },
];

const StoresAssignedToPO = () => {
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;
  const [selectedIds, setSelectedIds] = useState(["store_001"]);

  const { vendorId, purchaseOrderId } = useParams();

  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  useEffect(() => {
    if (!purchaseOrderId) return;

    fetchStores();
  }, [purchaseOrderId]);

  const fetchStores = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(
        `${serverURL}/purchaseOrder/getAllLinkedStores/${purchaseOrderId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        const formattedStores = (response.data.data || []).reduce(
          (acc, store) => {
            const phoneNumber = store.storeOwnerPhoneNumber;

            if (!phoneNumber) return acc;

            // Check if store already exists
            if (!acc[phoneNumber]) {
              acc[phoneNumber] = {
                details: {
                  id: store._id,
                  storeName: store.storeName,
                  storeOwnerName: store.storeOwnerName,
                  storeOwnerPhoneNumber: store.storeOwnerPhoneNumber,
                  address: store.address,
                  city: store.city,
                  state: store.state,
                  zipCode: store.zipCode,
                },
                products: [],
              };
            }

            // Add product to that store
            if (store.productId) {
              acc[phoneNumber].products.push({
                id: store.productId._id,
                productType: store.productId.productType,
                approvedWidth: store.productId.approvedWidth,
                approvedHeight: store.productId.approvedHeight,
              });
            }

            return acc;
          },
          {},
        );

        console.log("Formatted Stores:", formattedStores);

        // Object -> Array
        const storesArray = Object.values(formattedStores);

        setStores(storesArray);
      }
    } catch (error) {
      console.error(
        "Error fetching stores:",
        error.response?.data || error.message,
      );

      setError(error.response?.data?.message || "Failed to load stores.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-[calc(100vh-80px)] p-4">
      {/* Header */}
      <div className="flex gap-2">
        <div className="mb-2">
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
        </div>

        <div>
          <h2 className="mb-1 text-[13px] font-semibold uppercase tracking-wide text-gray-500">
            Stores
          </h2>

          <p className="mb-4 text-[13px] text-gray-500">
            {`Each store card can hold multiple products — tabs switch which
            product's details are shown.`}
          </p>
        </div>
      </div>

      <div className="h-[calc(100vh-150px)] overflow-auto">
        {loading ? (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <StoreCardSkeleton key={index} />
            ))}
          </div>
        ) : stores?.length === 0 ? (
          <div className="flex h-full items-center justify-center">
            <p className="text-[14px] text-gray-500">No stores found</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {stores.map((store) => (
              <StoreCard key={store.details.id} store={store} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default StoresAssignedToPO;
